import request from "../utils/request";

export function getAuthCode(phone) {
  return request.post(`/api/examinee/v1/user/authcode`, {
    phoneNumber: phone,
    smsType: 2, // 0 注册， 2 登录
  });
}

export function oldLogin(phone, authCode) {
  return request.post(`/api/examinee/v1/user/login`, {
    authCode,
    loginType: 1,
    phoneNumber: phone,
  });
}

export function login(phone, authCode) {
  return request.post(`/api/examinee/v1/user/quickRegister`, {
    phoneNumber: phone,
    authCode,
  });
}

export function getFaqList(collegeId) {
  return request.get(`/api/examinee/v1/message/faq/${collegeId}`);
}
